import React from 'react'
import { MdAccessTime } from 'react-icons/md';

const DateWithIcon = ({ date, color = 'text-system-light-40' }: { date: string, color?: string }) => {
    const originalDate = new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });
    return (
        <div className={`flex items-center gap-2 ${color}`}>
            <MdAccessTime />
            <span className={`text-bmedium ${color}`}>{originalDate}</span>
        </div>
    )
}

export default DateWithIcon